export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const NetworkContextName = 'NETWORK'
export const DEFAULT_TXN_DISMISS_MS = 25000